module.exports = __webpack_public_path__ + "media/71.5f4894b8.wav";